<template>
    <div>
        <h1 style="font-size: 24px; color: black;">机器人列表</h1>
    <div style="margin-bottom: 10px;">
      <table>
        <tr>
          <td>
            <el-button type="primary" @click="editDialogFun(true,'新增机器人')">新增</el-button>
          </td>
        </tr>
      </table>
    </div>
<div>
      <el-table border :data="robots">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="id"    label="id" >  </el-table-column>
        <el-table-column label="头像">
          <template slot-scope="scope">
            <template >
              <img :src="VUE_APP_CDN_URL+scope.row.head" width="80px" height="80px" alt=""/>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="机器人名称"></el-table-column>
        <el-table-column prop="type"    label="互动类型"  :formatter="typeFormatter">  </el-table-column>
        <el-table-column prop="interactLimit" label="每日互动次数"></el-table-column>
        <el-table-column prop="interactKeyword" label="互动关键字"></el-table-column>
        <el-table-column label="互动奖励" align="center">
          <template slot-scope="scope">
            <el-button plain size="mini" type="success" @click="showTypeConfig(scope.row)">配置奖励</el-button> 
          </template>
        </el-table-column>
        <el-table-column prop="interactReturn" label="互动返回文本"></el-table-column>
        <el-table-column prop="interactLimitText" label="超过次数返回文本"></el-table-column>
         <el-table-column label="开关" align="center" width="150px">
         <template slot-scope="scope">
                    <el-switch v-model="scope.row.isDelete"
                               :active-value="false"
                               :inactive-value="true"
                               active-text="开启"
                               inactive-text="关闭"
                               @change="update(scope.row)">
                    </el-switch>
           </template>
        </el-table-column>
        <el-table-column prop="createDt" label="创建时间" :formatter="formatDate"></el-table-column>
        <el-table-column prop="updateDt" label="更新时间" :formatter="formatDate"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button plain size="mini" type="success" @click="editDialogFun(true,'编辑',scope.row)">编辑</el-button> 
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="editDialog.title" center :visible.sync="editDialog.show" width="40%" :data="robot">
      <table style = "border-collapse:separate; border-spacing:30px;">
        <tr>
          <td><span>机器人名称:</span></td>
          <td colspan="2"> 
          <el-input   style="width: 220px" type="text" maxlength="10" placeholder="不超过10个字符" v-model="robot.name"></el-input> 
          </td>
        </tr>
        <tr >
          <td><span>机器人头像：</span></td>
          <td>
            <el-upload :headers="headers"
                       class="avatar-uploader"
                       :action="uploadURL"
                       :show-file-list="false"
                       :on-success="handleHeadSuccess"
                       :before-upload="beforeImageUpload">
              <img v-if="robot.head" :src="VUE_APP_CDN_URL+robot.head" class="avatar" alt=""/>
              <i v-else class="el-icon-picture avatar-uploader-icon"></i>
            </el-upload> 
          </td>
          <td><span>缩略图支持.png 或.jpg 格式，且不超过500kb</span></td>
        </tr>
        <tr>
          <td><span>互动类型：</span></td>
          <td colspan="2">
            <el-select v-model="robot.type" filterable placeholder="请选择"  >
              <el-option
                  v-for="item in typeValues"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr >
          <td><span>每日互动次数:</span></td>
          <td colspan="2"> 
            <el-input-number  :min="1" :max="100" style="width: 220px" type="text" v-model="robot.interactLimit"> </el-input-number>
          </td>
        </tr>
        <tr>
          <td><span>互动关键词:</span></td>
          <td colspan="2"> 
          <el-input   style="width: 220px" type="text" maxlength="10" placeholder="不超过10个字符" v-model="robot.interactKeyword"></el-input> 
          </td>
        </tr>
        <tr>
          <td><span>互动返回文本:</span></td>
          <td colspan="2"> 
          <el-input   style="width: 420px" type="text" maxlength="100" placeholder="不超过100个字符" v-model="robot.interactReturn"></el-input> 
          </td>
        </tr>
        <tr>
          <td><span>超过次数返回文本:</span></td>
          <td colspan="2"> 
          <el-input   style="width: 420px" type="text" maxlength="100" placeholder="不超过100个字符" v-model="robot.interactLimitText"></el-input> 
          </td>
        </tr>
        <!-- 这里用的el-form-item 不是 tr 看看兼容问题 -->
          <!-- <el-form-item  label="互动返回文本" :label-width="labelWidth">
              <el-input :rows="5"  style="width: 400px" type="textarea" placeholder="请输入内容" v-model="matchEditForm.text"></el-input>
          </el-form-item> -->
        <tr>
          <td style="text-align-last: center;" colspan="3">
            <el-button plain size="middle" type="success" @click="saveOrUpdatePrize">确定</el-button>
            <el-button plain size="middle" type="danger" @click="editDialogFun(false)">返回</el-button>
          </td>
        </tr>
      </table>
    </el-dialog>
    <el-dialog :title="messageDialog.title" center :visible.sync="messageDialog.show" width="30%">
      <h1 v-html="messageDialog.message"/>
      <el-button plain size="mini" type="success" @click="messageDialogFun(false)">确定</el-button>
    </el-dialog>
<!-- 配置奖励部分dialog  lucky部分-->
    <el-dialog v-if="luckyVisible"  :center="true" :close-on-click-modal="false" :visible.sync="luckyVisible" width="80%" :show-close="false" :data="luckyConfigList">

      <el-tabs v-model="luckyConfigType" type="card" @tab-click="handleLuckyClick">
          <el-tab-pane
            :key="item.id"
            v-for="(item) in luckyTypes"
            :label="item.name"
            :name="item.id+''"
          >
          </el-tab-pane>
      </el-tabs> 
        <div style="margin-bottom:10px">
          <el-button plain size="middle" type="success" @click="createLuckyConfig">新增条目</el-button>
          <el-button plain size="middle">总权重为：{{totalConfigWeight}}</el-button>
        </div>
        <el-table  border :data="luckyConfigList" tooltip-effect="dark" style="width: 100%"> 
                    <el-table-column type="index" label="编号" width="50"></el-table-column>
                    <el-table-column prop="id" label="id" width="50"></el-table-column>
                    <el-table-column v-if="luckyConfigType==='0'" label="运势最小值" prop="min" align="center">
                        <template slot-scope="scope" >
                            <el-input-number size="mini" v-model="scope.row.min" ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="luckyConfigType==='0'" label="运势最大值" prop="max" align="center">
                        <template slot-scope="scope" >
                            <el-input-number size="mini" v-model="scope.row.max" ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column v-else-if="luckyConfigType==='4'" label="背景图片" prop="detail" align="center">
                      <template slot-scope="scope" >
                          <el-upload :headers="headers"
                                    class="avatar-uploader"
                                    :action="uploadURL"
                                    :show-file-list="false"
                                    :on-success="(data)=>handleConfigBackPicSuccess(data,scope.row)"
                                    :before-upload="beforeImageUpload">
                            <img v-if="scope.row.detail" :src="VUE_APP_CDN_URL+scope.row.detail" class="avatar" alt=""/>
                            <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                          </el-upload> 
                      </template>
                    </el-table-column>

                    <el-table-column v-else prop="detail" align="center"  label="描述" width="200px">
                      <template slot-scope="scope" >
                            <el-input size="mini" v-model="scope.row.detail" ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="权重" align="center" prop="weight">
                        <template slot-scope="scope" >
                            <el-input-number size="mini" v-model="scope.row.weight"  ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" type="danger"
                                        @click.native.prevent="deleteRow(scope.$index, scope.row)">移除</el-button>
                        </template>
                    </el-table-column>
       </el-table>
      <span slot="footer" class="dialog-footer">
            <el-button plain size="middle" type="success" @click="saveLuckyConfigs">提交当前页信息</el-button>
            <el-button plain size="middle" type="danger" @click="closeLuckyConfig">返回</el-button>
      </span>
    </el-dialog>

    <!-- 配置奖励 normal部分 注意这里有个bug 就是下面根据v-if判断类型显示不同列的时候如果el-dialog不加v-if时列显示会窜位置 可能是element的bug 必须保留v-if和 ：visible.sync-->
    <el-dialog v-if="normalVisible"  :center="true" :close-on-click-modal="false" :visible.sync="normalVisible" width="80%" :show-close="false"  :data="normalConfigList">
        <div style="margin-bottom:10px">
          <el-button plain size="middle" type="success" @click="createNormalConfig">新增条目</el-button>
          <el-button plain size="middle">总权重为：{{totalConfigWeight}}</el-button>
        </div>
        <el-table  border :data="normalConfigList" tooltip-effect="dark" style="width: 100%"> 
                    <el-table-column type="index" label="编号" width="50"></el-table-column>
                    <el-table-column prop="id" label="id" width="50"></el-table-column>
                    <!-- <el-table-column v-if="configRobotType==2" prop="detail" align="center"  label="描述" width="200px">
                      <template slot-scope="scope" >
                            <el-input size="mini" v-model="scope.row.detail" ></el-input>
                        </template>
                    </el-table-column>                     -->
                    <el-table-column v-if="configRobotType==1" width="300px" label="游戏名称"  align="center">
                        <template slot-scope="scope" >
                          <el-cascader 
                                v-model="scope.row.tempId"
                                :options="allGameList"
                                @change="changeVideo(scope.row)" clearable filterable :show-all-levels="true" > 
                                </el-cascader>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="configRobotType==1" label="视频id" prop="relId" align="center"></el-table-column>                    
                    <el-table-column v-if="configRobotType==1" label="视频预览"   align="center">
                        <template slot-scope="scope">
                          <template v-if="scope.row.videoPath">
                            <video :src="VUE_APP_CDN_URL+scope.row.videoPath" class="avatar1" controls="controls"/>
                          </template>
                        </template>
                    </el-table-column>                    
                    <el-table-column v-if="configRobotType==1" label="游戏id" prop="gameId" align="center"></el-table-column>                    
                    <el-table-column v-if="configRobotType==1" :label="`游戏名称${configRobotType}`" prop="gameName" align="center"></el-table-column>      
                    <el-table-column v-if="configRobotType==2" label="奖励道具" prop="relId" align="center">
                        <template slot-scope="scope" >
                              <el-select  @change="changePackage(scope.row)"    v-model="scope.row.relId" filterable placeholder="请选择/输入"  >
                                  <el-option
                                      v-for="item in packages"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                                </el-select> 
                        </template>
                    </el-table-column>                    
                    <el-table-column v-if="configRobotType==2" label="道具图标"  align="center">
                        <template slot-scope="scope">
                          <template v-if="scope.row.goodImg">
                            <img   :src="VUE_APP_CDN_URL+scope.row.goodImg" class="avatar" alt=""/>
                          </template>
                        </template>
                    </el-table-column>                    
                    <el-table-column v-if="configRobotType==2" label="数量" align="center" prop="number">
                        <template slot-scope="scope" >
                            <el-input-number size="mini" v-model="scope.row.number"  ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column label="权重" align="center" prop="weight">
                        <template slot-scope="scope" >
                            <el-input-number size="mini" v-model="scope.row.weight"  ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" type="danger"
                                        @click.native.prevent="deleteNormalRow(scope.$index, scope.row)">移除</el-button>
                        </template>
                    </el-table-column>
       </el-table>
      <span slot="footer" class="dialog-footer">
            <el-button plain size="middle" type="success" @click="saveNormalConfigs">提交当前页信息</el-button>
            <el-button plain size="middle" type="danger" @click="closeNormalConfig">返回</el-button>
      </span>
    </el-dialog>
    </div>
</template>

<script>

import utils from '@/utils'
import { 
     
  robotTypes, allRobotList,addRobot,editRobot,changeRobotDelete,
  robotConfigList,luckyConfigTypes,batchAddLuckyConfigs,gameRunningList,
  allEnablePacketList,batchAddNormalConfigs,videoList} from "@/http/api";
export default {
  inject: ['reload'],
  name: "RobotManage",
  data() {
    return {
      loading: false,
      editDialog: {
        show: false,
        title: null
      },
      VUE_APP_BASE_URL: null,
      VUE_APP_CDN_URL: null,
      uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
      typeValues: [ ], 
      luckyTypes:[],
      robot: {
        id: null,
        type: null,
        name: null,
        head:null,
        interactLimit: null,
        interactKeyword: null,
        interactReturn: null,
        interactLimitText:null,
        isDelete:null
      }, 
      robots: null,
      //编辑标志位
      editFlag : false, 
      headers: {},
      messageDialog: {
        show: false,
        title: null,
        message: null
      },
      luckyVisible:false,
      normalVisible:false, 
      luckyConfigType:'0',
      luckyTypeName:null,
      configRobotId:null,
      configRobotType:null,
      configLuckyType:'0',
      luckyConfigList:[],
      normalConfigList:[],
      totalConfigWeight:0,

      allGameList:[],
      packages:[],
      allVideos:[],
      filterVideos:[],
    }
  },
  methods: {
    formatDate: function(row, column, cellValue) {
                return utils.DateUtil.formatDate(cellValue, "yyyy-MM-DD HH:mm:ss")
     },
    typeFormatter: function (row, column, cellValue){
      var temp="其他"
      this.typeValues.forEach( item => {
        if(item.id===cellValue){
               temp=item.name;
            } 
      })
      return temp
    },
     allRobot(){
        allRobotList().then(resp=>{
        //  console.log(resp.data.info)
        this.robots=resp.data.info
        this.headers = {Authorization: this.$store.state.user.token};
            });
     },
    saveOrUpdatePrize() {
      if (this.robot.type == null) {
        this.$message.error('物品类型不能为空！');
        return;
      }
      if (this.robot.name == null) {
        this.$message.error('物品名称不能为空！');
        return;
      }
      if (this.robot.isForever == false) {
        if(this.robot.expireDays==0){
          this.$message.error('有效期不能为0!');
          return;
        }
        
      }
      if(this.editFlag){
        editRobot(this.robot).then(resp => {
        if (resp.data.status === 0) {
          this.editDialogFun(false);  
          this.$message.success('修改成功');
          this.reload();  
        }else{
          this.$message.error('修改失败');
        }
      });
      }else{
          addRobot(this.robot).then(resp => {
        if (resp.data.status === 0) {
          this.editDialogFun(false);  
          this.$message.success('新增成功');
          this.reload();  
        }else{
          this.$message.error('新增失败');
        }
      });
      } 
      
    }, 
      update(row){
      // 修改开关更新方法 只需要传入id即可进行转换  ------------------------------------------
      changeRobotDelete(row.id,row.isDelete).then(resp=>{
          if (resp.data.msg==='成功'){ 
             this.$message.success('修改成功');
                  // this.reload();  
          }else{
            this.$message.error('修改失败');
          }
      });
  },

    handleHeadSuccess(data) {
      this.robot.head = data.info;
    }, 
    handleConfigBackPicSuccess(data,row) {
      console.log(row)
      console.log(data)
      row.detail = data.info;
    }, 
    beforeImageUpload(data) {
      const type = data.name.substring(data.name.lastIndexOf('.')) === '.png' || data.name.substring(data.name.lastIndexOf('.')) === '.jpg';
      const size = data.size < 1024 * 5000;
      if (!type) {
        this.$message.error('上传图片只能是png,jgp格式!');
      }
      if (!size) {
        this.$message.error('上传图片大小不能超过5000kb!');
      }
       
      return type && size;
    }, 
    upload() {
      return this.VUE_APP_BASE_URL + 'packet/upload';
    },
    editDialogFun(show, title, data) {
      this.editDialog.show = show;
      this.editDialog.title = title;
 
      this.editFlag=false;
      this.robot.id=null,
      this.robot.type= null,
      this.robot.name= null,
      this.robot.head=null,
      this.robot.interactLimit= null,
      this.robot.interactKeyword= null,
      this.robot.interactReturn= null,
      this.robot.interactLimitText=null,
      this.robot.isDelete=false;
      if (show && data) { 
      this.robot.id=data.id;
      this.robot.type= data.type;
      this.robot.name= data.name;
      this.robot.head=data.head;
      this.robot.interactLimit= data.interactLimit,
      this.robot.interactKeyword= data.interactKeyword,
      this.robot.interactReturn= data.interactReturn,
      this.robot.interactLimitText=data.interactLimitText,
      this.robot.isDelete=data.isDelete;
        //设置编辑标志位
        this.editFlag=true;
      }

    },
    messageDialogFun(show, title, message) {
      this.messageDialog.show = show;
      this.messageDialog.title = title;
      this.messageDialog.message = message;
    }, 
    showTypeConfig(row){
      //如果为3 说明是运势类型
      this.configRobotId=row.id;
      this.configRobotType=row.type;
      this.configLuckyType='0';
      if(row.type==3){
        //设置展示dialog
        this.luckyVisible=true;
        this.normalVisible=false;
        robotConfigList(this.configRobotId,this.configRobotType,this.configLuckyType).then(resp => {
          this.luckyConfigList=resp.data.info;
        })
      }else{
        this.luckyVisible=false;
        this.normalVisible=true;
        robotConfigList(this.configRobotId,this.configRobotType,this.configLuckyType).then(resp => {
          //初始化两种情况 如果robotType为又来抽卡需要设置头像 如果是玩什么需要设置游戏信息
          let tempConfigList=resp.data.info;
          if(this.configRobotType==1){
            //处理游戏数据
            tempConfigList.forEach(  (item) => {
              let video= this.allVideos.find(v => v.id==item.relId);
              let game = this.allGameList.find(g => g.id==video.gameId);
              item.videoPath=video.videoPath;
              item.gameId=video.gameId;
              item.gameName=game.name;
              //设置下拉框的临时数组
              item.tempId=[video.gameId,video.id];
            })
          }else if(this.configRobotType==2){
            tempConfigList.forEach( item => {
              // console.log(item)
              if(item.relId!==null){
                let good= this.packages.find( g => g.id==item.relId);
                // console.log(good)
                item.goodImg=good.smallImage;
              }
            })
          }
            // console.log(tempConfigList)
          this.normalConfigList=tempConfigList;
        })
      }
    },
    handleLuckyClick(tab) {
      this.configLuckyType=tab.name
      this.luckyTypeName=tab.label
      console.log(this.luckyTypeName)
        robotConfigList(this.configRobotId,this.configRobotType,this.configLuckyType).then(resp => {
          this.luckyConfigList=resp.data.info;
        })
      },
      deleteRow(index) {
          this.luckyConfigList.splice(index, 1);
      },
      closeLuckyConfig(){
          this.luckyVisible=false;
          this.luckyConfigType='0';
          this.luckyConfigList=[]
      },
      createLuckyConfig(){
        this.luckyConfigList.unshift({
          chatRoomRobotId: this.configRobotId,
          type:this.luckyConfigType,
          weight:0,
          detail:null,
          min:0,
          max:0
        })
        // console.log(this.luckyConfigList)
      },
      saveLuckyConfigs(){
          batchAddLuckyConfigs(this.luckyConfigList).then(resp => {
                    if (resp.data.status === 0) {
                        // this.editDialogFun(false);  
                        this.$message.success('更新成功');
                        this.reload();  
                      }else{
                        this.$message.error('更新失败');
                      }
          })
      },
      createNormalConfig(){
        this.normalConfigList.unshift({
          chatRoomRobotId: this.configRobotId,
          type:this.configRobotType,
          relId:null,
          weight:0,
          name:null,
          
          gameId:null,
          videoPath:null,
          gameName:null,
          goodImg:null
        })
        // console.log(this.luckyConfigList)
      },
      deleteNormalRow(index) {
          this.normalConfigList.splice(index, 1);
      },
      closeNormalConfig(){
          this.normalVisible=false;
          this.normalConfigList=[]
      }, 
      saveNormalConfigs(){
          batchAddNormalConfigs(this.normalConfigList).then(resp => {
                    if (resp.data.status === 0) {
                        // this.editDialogFun(false);  
                        this.$message.success('更新成功');
                        this.reload();  
                      }else{
                        this.$message.error('更新失败');
                      }
          })
      }, 
      changeVideo(row){
        //  console.log(row)
         let videoId=row.tempId[1];
         let gameId=row.tempId[0];
        let video= this.allVideos.find(v => v.id==videoId);
        let game = this.allGameList.find(g => g.id==gameId);
        row.videoPath=video.videoPath;
        row.gameId=video.gameId;
        row.gameName=game.name;
        row.relId=videoId;
      },
      changePackage(row){
        // console.log(row)
        // console.log(item)
        if(row.relId!==null){
          let good= this.packages.find( g => g.id==row.relId);
          // console.log(good)
          row.goodImg=good.smallImage;
        }
      }
  },
  created() {
     this.allRobot();
     luckyConfigTypes().then(resp => {
       this.luckyTypes=resp.data.info;
     })
     robotTypes().then(resp => {
       this.typeValues=resp.data.info;
     }) 
      gameRunningList().then(resp=>{
      this.allGameList=resp.data.info;
        videoList().then(resp => {
          this.allVideos=resp.data.info
          //处理数组 label value
          this.allVideos.forEach(item => {
            item.value=item.id;
            item.label=item.name;
            // 判断叶子节点标志位
            item.leaf=1;
          })
          this.allGameList.forEach( item => {
            item.value=item.id;
            item.label=item.name;
            item.children= this.allVideos.filter( video => { return video.gameId==item.id})
          })
        })
        // console.log(this.allGameList);
      })
      allEnablePacketList().then(resp=>{
        this.packages=resp.data.info
      });

  },
  watch:{
            luckyConfigList: {
                deep:true,
                handler(val) {
                  console.log("重新计算luckyList权重")
                   var totalWeight=0;
                   val.forEach(function(item){
                    totalWeight+=item.weight;
                   })
                   this.totalConfigWeight=totalWeight;
                }
            },
            normalConfigList: {
                deep:true,
                handler(val) {
                  console.log("重新计算normalList权重")
                   var totalWeight=0;
                   val.forEach(function(item){
                    totalWeight+=item.weight;
                   })
                   this.totalConfigWeight=totalWeight;
                }
            },
        },
  mounted() {
    this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
    this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
  }
}






    
</script>

<style scoped>

</style>
